var modCookies = function(){
    var scope = ".js-mod-cookies";

    function gtagConsent(config){
        if (typeof gtag === 'function') {
            gtag('consent', 'update', config);
        }
    }

    ui.ready(
        scope,
        function($mod){
            var cookieN = "cookiesok";
            var cookieV = "ok";
            var cookie = cookies.read(cookieN);
            var $cookies = $("#cookiemod");
            if(cookie!=cookieV){
                $cookies.css("display","block");
            }
            $cookies.toggle(cookie!=cookieV);

            $mod.find(scope+"__accept-all").click(
                function(ev){
                    ev.preventDefault();
                    cookies.create(cookieN,cookieV,365);
                    gtagConsent({
                        ad_storage: 'granted',
                        analytics_storage: 'granted',
                        functionality_storage: 'granted',
                        personalization_storage: 'granted',
                        ad_user_data: 'granted',
                        ad_personalization: 'granted'
                    });
                    $cookies.css("display","none");

                }
            );

            $mod.find(scope+"__configure").click(
                function(ev){
                    ev.preventDefault();
                    $cookies.find(scope+"__config").toggle();
                }
            );

            $mod.find(scope+"__confirm-config").click(
                function(ev){
                    ev.preventDefault();
                    cookies.create(cookieN,cookieV,365);

                    var allowFunctional = $cookies.find('input[name="consent_functional"]').is(':checked');
                    var allowAnalytics = $cookies.find('input[name="consent_analytics"]').is(':checked');
                    var allowAds = $cookies.find('input[name="consent_ads"]').is(':checked');
                    var allowUserdata = $cookies.find('input[name="consent_userdata"]').is(':checked');
                    var allowPersonalization = $cookies.find('input[name="consent_personalization"]').is(':checked');
                    var allowPersonalizationStorage = $cookies.find('input[name="consent_personalization_storage"]').is(':checked');

                    gtagConsent({
                        ad_storage: allowAds ? 'granted' : 'denied',
                        analytics_storage: allowAnalytics ? 'granted' : 'denied',
                        functionality_storage: 'granted',
                        personalization_storage: allowPersonalizationStorage ? 'granted' : 'denied',
                        ad_user_data: allowUserdata ? 'granted' : 'denied',
                        ad_personalization: allowPersonalization ? 'granted' : 'denied'
                    });

                    $cookies.css("display","none");
                }
            );
        }

    );
}();